import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import CroppedImage from 'rebook/apps/utils/components/CroppedImage';
import VerticalBookCard from 'rebook/apps/books/components/VerticalBookCard';
import pluralize from 'rebook/apps/utils/text/pluralize';
import { Author } from 'rebook/apps/catalog/models';

import styles from './style.scss';


const AuthorAudiobooksBlock = ({ isAudioBook, authorAudioBookList }) => {
  if (!authorAudioBookList || authorAudioBookList.length === 0) {
    return null;
  }
  const headerText = isAudioBook ? 'Другие аудиокниги автора' : 'Аудиокниги автора';
  return (
    <div className="jest-author-audiobooks-block">
      <div className={styles.container}>
        <h3>{headerText}</h3>
      </div>
      <ContentCarousel>
        {authorAudioBookList}
      </ContentCarousel>
    </div>
  );
};

const AuthorBooksBlock = ({ isAudioBook, authorBookList }) => {
  if (!authorBookList || authorBookList.length === 0) {
    return null;
  }
  const headerText = isAudioBook ? 'Книги автора' : 'Другие книги автора';
  return (
    <div className="jest-author-books-block">
      <div className={styles.container}>
        <h3>{headerText}</h3>
      </div>
      <ContentCarousel>
        {authorBookList}
      </ContentCarousel>
    </div>
  );
};

const BookDetailAuthorBookList = ({ book, authorBooks, authorAudioBooks }) => {
  const mainAuthor = book.main_author ? new Author(book.main_author) : null;

  if (authorBooks.length === 0 && authorAudioBooks.length === 0) {
    return null;
  }
  const isAudioBook = get(book, 'type', '') === 'audio';

  let bookCounter = get(mainAuthor, 'counters.books', 0);
  /**
   * Так как мы запрашиваем книги автора за исключением той,
   * что открыта (/api/books/?authors={id}&id__ne={bookId}&limit=10)
   * в счетчике приходит полная сумма всех книг, без учета того что мы исключили из выдачи.
   * Для обработки этого случая используется условие ниже
   */
  bookCounter = bookCounter !== 0 ? bookCounter - 1 : 0;
  let authorBookList = [];
  let authorAudioBookList = [];
  if (authorBooks) {
    authorBookList = authorBooks.map((item) => (
      <VerticalBookCard
        key={item.id}
        book={item} />
    ));
  }
  if (authorAudioBooks) {
    authorAudioBookList = authorAudioBooks.map((item) => (
      <VerticalBookCard
        key={item.id}
        book={item} />
    ));
  }
  const isAnonymousAuthor = !get(mainAuthor, 'cover_name.length', 0);

  return (
    <div className="billetContainerNoOverflow jest-author-book-list">
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <h2>Автор</h2>
        </div>

        <div className={styles.author}>
          {mainAuthor && !isAnonymousAuthor && (
            <Link to={mainAuthor.getLink()}>
              <CroppedImage
                height="40"
                width="40"
                src={mainAuthor.photo}
                alt={mainAuthor.cover_name} />
            </Link>
          )}

          <div className={styles.authorInfo}>
            <div className={styles.authorName}>
              {mainAuthor && (
                <Link to={mainAuthor.getLink()}>
                  {mainAuthor.cover_name}
                </Link>
              )}
            </div>
            {mainAuthor && !isAudioBook && (
              <div className={styles.authorBooks}>
                {bookCounter}
                &nbsp;{pluralize(bookCounter, 'книга', 'книги', 'книг')}
              </div>
            )}
          </div>
        </div>
        {isAudioBook ? (
          <React.Fragment>
            <AuthorAudiobooksBlock isAudioBook={isAudioBook} authorAudioBookList={authorAudioBookList} />
            <AuthorBooksBlock isAudioBook={isAudioBook} authorBookList={authorBookList} />
          </React.Fragment>
        )
          : (
            <React.Fragment>
              <AuthorBooksBlock isAudioBook={isAudioBook} authorBookList={authorBookList} />
              <AuthorAudiobooksBlock isAudioBook={isAudioBook} authorAudioBookList={authorAudioBookList} />
            </React.Fragment>
          )
        }
      </div>
    </div>
  );
};

BookDetailAuthorBookList.propTypes = {
  book: PropTypes.shape({
    id: PropTypes.number.isRequired,
    main_author: PropTypes.shape({
      id: PropTypes.number.isRequired,
      photo: PropTypes.string.isRequired,
      cover_name: PropTypes.string.isRequired,
      active_book_count: PropTypes.number.isRequired,
    }),
  }).isRequired,
  authorBooks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ),
};

export default BookDetailAuthorBookList;
